<template>
    <footer v-if="client" class="footer-back" :class="{ 'opened': isOpenMobileMenu }">
        <div class="bng-basement">
            <div class="bng-basement-container">
                <div class="level navigation is-marginless level-links">
                    <div class="level-item level-languages" v-if="isShowLanguages">
                        <!-- <div class="level-item__inner"> -->
                        <!-- languages -->
                        <h6 class="title level-title is-uppercase">{{ "components.common.basement.language" | translate }}</h6>
                        <div class=" level-item__list">
                            <languages />
                        </div>

                        <!-- timezones -->
                        <!--
                        <h6
                            class="title is-6 is-uppercase"
                            style="margin-top:1rem;"
                        >{{ "components.common.basement.timezone" | translate }}</h6>
                        <timezones />
                        -->
                        <!-- </div> -->
                    </div>

                    <!-- categories -->
                    <div v-if="client.view.categories" class="level-item level-categories" :class="{'level-item--active' : isOpenedCategoriesMobile}">
                        <div class="level-item__inner">
                            <h6 class="title level-title is-uppercase">{{ "components.common.basement.categories.title" | translate }}
                            </h6>
                            <categories />
                        </div>
                        <div class="level-item__button" @click="isOpenedCategoriesMobile=!isOpenedCategoriesMobile"></div>
                    </div>

                    <!-- payment methods -->
                    <div v-if="client.view.payments.paymentMethods && client.view.payments.paymentMethods.length"
                        class="level-item level-payment" 
                        :class="{'level-item--active' : isOpenedPaymentsMobile}">
                        <div class="level-item__inner">
                            <h6 class="title level-title is-uppercase">{{ "components.common.basement.payment methods.title" |
                                translate }}</h6>
                            <div>
                                <div class="level-item__list">
                                    <router-link v-for="paymentMethod in client.view.payments.paymentMethods"
                                        :key="paymentMethod" :to="paymentRoute"
                                        class="basement-link bng-clickable bng-underlined">{{
                                            `components.common.basement.payment methods.${paymentMethod}` | translate
                                        }}</router-link>
                                </div>
                            </div>
                        </div>
                        <div class="level-item__button" @click="isOpenedPaymentsMobile=!isOpenedPaymentsMobile"></div>

                    </div>

                    <!-- rules -->
                    <div class="level-item level-rules" :class="{'level-item--active' : isOpenedRulesMobile}">
                        <div class="level-item__inner">
                            <h6 class="title level-title is-uppercase">{{ "components.common.basement.rules.title" | translate }}</h6>
                            <div>
                                <rules />
                                <div class="level-item__list">
                                    <a
                                        @click="goToBonusRules()"
                                        class="basement-link bng-clickable bng-underlined"
                                    >
                                        {{ "components.common.basement.rules.bonus-rules" | translate }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="level-item__button" @click="isOpenedRulesMobile=!isOpenedRulesMobile"></div>
                    </div>

                    <!-- contacts -->
                    <div v-if="client.support.feedbackForm || (client.support.contacts && client.support.contacts.length)"
                        class="level-item level-social"
                        :class="{'level-item--active' : isOpenedContactsMobile}">
                        <div class="social level-item__inner ">
                            <h6 class="title level-title is-uppercase">{{ "components.common.basement.contacts.title" | translate }}
                            </h6>
                            <div class="level-item__list">
                                <p v-if="client.support.feedbackForm" class="is-size-9">
                                    <span class="icon">
                                        <i class="far fa-comment-dots"></i>
                                    </span>
                                    <span class="bng-clickable bng-underlined" @click="openLiveChat()">Live Support</span>
                                </p>
                                <p v-for="link in client.support.contacts" :key="link.url" class="is-size-9">
                                    <template v-if="link.iconHtml"><span v-html="link.iconHtml" class="icon"></span></template>
                                    <a v-if="link.url" class="bng-clickable bng-underlined" :href="link.url"
                                        target="_blank">{{ link.text || link.url }}</a>
                                    <span v-else>{{ link.text }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="level-item__button" @click="isOpenedContactsMobile=!isOpenedContactsMobile"></div>
                    </div>

                </div>

                <hr class="is-marginless" />

                <div class="level level-underline level-data">
                    <div v-if="client.view.legal.organizationInfo" class="level-item">
                        <div class="level-item__wrapper">
                            <div class="level-item__text">
                                <string-content :content-ref="client.view.legal.organizationInfo" />
                            </div>
                        </div>
                    </div>
                    <div class="level-item">
                        <div class="level-item__wrapper">
                            <div>
                                <span class="age18 is-size-5">
                                    <span>18+</span>
                                </span>
                            </div>
                            <div v-if="client.view.legal.mainProvisions" class="level-item__text">
                                <string-content :content-ref="client.view.legal.mainProvisions" />
                            </div>
                        </div>
                    </div>
                    <div class="level-item">
                        <div class="payment-methods">
                            <img v-if="isMobile" v-for="paymentMethod in client.view.payments.paymentMethods"
                                :class="{ 'single': client.view.payments.paymentMethods.length == 1, 'multiple': client.view.payments.paymentMethods.length > 1 }"
                                :key="paymentMethod" :src="`/static/payments/white/${paymentMethod}.svg`" />
                            <img v-if="!isMobile" v-for="paymentMethod in client.view.payments.paymentMethods"
                                :class="{ 'single': client.view.payments.paymentMethods.length == 1, 'multiple': client.view.payments.paymentMethods.length > 1 }"
                                :key="paymentMethod" :src="`/static/payments/gray/${paymentMethod}.svg`" />
                            <div class="level-item bng-certificates">
                                <a v-if="client.curacao.logoScriptId"
                                    class="curacao-logo"
                                    :href="`https://verification.curacao-egaming.com/validateview.aspx?domain=${client.curacao.logoScriptId}`"
                                    target="_blank">
                                    <img :src="`https://verification.curacao-egaming.com/validate.ashx?domain=${client.curacao.logoScriptId}`"
                                        alt="" width="100" />
                                </a>
                                <a v-if="client.gcb.token && client.gcb.image"
                                    class="gcb-logo"
                                    :href="`https://cert.gcb.cw/certificate?id=${client.gcb.token}`"
                                    target="_blank">
                                    <img :src="`https://seal.cgcb.info/${client.gcb.image}`" />
                                </a>
                            </div>
                            <div v-if="client.view.banners.iTechLabsBanner">
                                <img class="level-rng" src="/static/rng_blue.gif" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import Vue from 'vue';

import Languages from './languages.vue';
import Timezones from './timezones.vue';
import Categories from './categories.vue';
import Rules from './rules.vue';
import StringContent from '../../../../../_common/components/content/string-content.js';
import isMobile from 'ismobilejs';

export default {
    name: 'basement',
    components: { Languages, Timezones, Categories, Rules, StringContent },
    props: ["isOpenMobileMenu"],
    data() {
        return {
            isMobile: isMobile.phone || isMobile.tablet,
            isOpenedCategoriesMobile: true,
            isOpenedRulesMobile: false,
            isOpenedPaymentsMobile: false,
            isOpenedContactsMobile: false,
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        availableLanguages() {
            return Vue.state.lang.availableLanguages;
        },
        isShowLanguages() {
            return this.availableLanguages && this.availableLanguages.length > 1;
        },
        paymentRoute() {
            return Vue.state.player.isLoggedIn()
                ? {
                    name: 'profile',
                    hash: '#deposit'
                }
                : { name: 'registration' };
        }
    },
    watch: {
        isOpenMobileMenu(newValue) {
            if (newValue == true) {
                document.documentElement.style.setProperty('--navigationHeightMobile', document.querySelector("#navigation").offsetHeight + 'px');
                document.documentElement.classList.add("overflow-hidden");
            } else {
                document.documentElement.classList.remove("overflow-hidden");
            }
        }
    },
    async mounted() {
        await Vue.state.client.ensure();
    },
    methods: {
        async goToBonusRules() {
            await Vue.router.teleport.bonusRules();
        },
        openLiveChat(){
            return window.Tawk_API && window.Tawk_API.toggle();
        },
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/basement/basement.vue